import { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app';
import { logout, selectAppDevice, selectAppState, selectAuth } from 'slice';
import { DEVICES, handleRedirectSignIn } from 'utils';

import ErrorDigitalMenuDesktop from './ErrorDigitalMenuDesktop';
import ErrorDigitalMenuMobile from './ErrorDigitalMenuMobile';

type ErrorDigitalMenuProps = {
  error?: string;
  statusCode?: number;
};

const ErrorAuth = ({ error, statusCode }: ErrorDigitalMenuProps) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const app = useAppSelector(selectAppState);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const appDevice = useAppSelector(selectAppDevice);
  const auth = useAppSelector(selectAuth);

  const onSignIn = async () => {
    setIsLoading(true);
    try {
      if (!auth.isLogout) {
        await dispatch(logout()).unwrap();
      }

      handleRedirectSignIn(
        history,
        '/sign-in',
        appDevice.isSpecificBrowser,
        app?.domains?.hubIdentity?.domain
      );
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('An error occurred while logging out', err);
    } finally {
      setIsLoading(false);
    }
  };

  const onSignUp = async () => {
    setIsLoading(true);
    try {
      if (!auth.isLogout) {
        await dispatch(logout()).unwrap();
      }

      handleRedirectSignIn(
        history,
        '/sign-in',
        appDevice.isSpecificBrowser,
        app?.domains?.hubIdentity?.domain
      );
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('An error occurred while logging out', err);
    } finally {
      setIsLoading(false);
    }
  };

  const formatProps = () => {
    return {
      error,
      onSignIn,
      onSignUp,
      isLoading,
      statusCode,
    };
  };

  const renderElements = {
    [DEVICES.DESKTOP]: <ErrorDigitalMenuDesktop {...formatProps()} />,
    [DEVICES.TABLET]: <ErrorDigitalMenuMobile {...formatProps()} />,
    [DEVICES.MOBILE]: <ErrorDigitalMenuMobile {...formatProps()} />,
  };

  return renderElements[appDevice.device];
};

export default ErrorAuth;
